import React from "react"
import { Link } from "gatsby"

import { CaretIcon } from "components/page-components/Icons/small"

export const DropdownMenu = ({
  label,
  link,
  dropdown_menu_items,
  page,
  is_right,
}) => {
  const is_partially_active_dropdown_trigger = ({ isPartiallyCurrent }) => ({
    className: `navbar-item is-submenu${isPartiallyCurrent ? " is-currently-active" : ""}`,
  })

  return (
    <div className="navbar-item has-dropdown is-hoverable is-submenu">
      {link ? (
        <Link to={link} getProps={is_partially_active_dropdown_trigger}>
          <span className="header-link">
            {label}
            <span className="ml-2">
              <CaretIcon
                {...{
                  size: 0.8,
                  rotation: "down",
                  color: "#FFFFFF",
                }}
              />
            </span>
          </span>
        </Link>
      ) : (
        <div className="m-auto is-clickable">
          <span className="header-link">
            {label}
            <span className="ml-2">
              <CaretIcon
                {...{
                  size: 0.8,
                  rotation: "down",
                  color: "#FFFFFF",
                }}
              />
            </span>
          </span>
        </div>
      )}
      <div
        className={`navbar-dropdown is-boxed is-submenu${
          is_right ? " is-right" : ""
        }`}
        page={page}
      >
        {dropdown_menu_items.map(
          ({ link, label, additional_classes }, index) => {
            const is_partially_active_dropdown_link = ({
              isPartiallyCurrent,
            }) => ({
              className: `navbar-item is-submenu-dropdown${isPartiallyCurrent ? " is-currently-active" : ""}${!!additional_classes?.[0] ? ` ${additional_classes?.join(" ")}` : ""}`,
            })

            return (
              <Link
                key={`submenu_dropdown_link-${index}`}
                to={link}
                getProps={is_partially_active_dropdown_link}
              >
                <span className="submenu-dropdown-header-link">{label}</span>
              </Link>
            )
          }
        )}
      </div>
    </div>
  )
}
